<template>
  <div class="EngagementFinder">
    <div class="EngagementFinderContainer">
      <div class="header">
        <div class="searchPart">
          <div class="Title">Credentials Published</div>
          <div class="searchBtn">
            <div class="inpSearchDiv">
              <input
                v-model="MultiFilter"
                @keyup.enter="Filter()"
                type="text"
                placeholder="Search a credential"
                class="inpSearch"
              />
              <i
                aria-hidden="true"
                @click="Filter()"
                class="v-icon searchIcon material-icons theme--light"
              >search</i>
            </div>
            <div class="filtrePart">
              <div class="OneFilter firstFilter" v-on:click="toggleTax()">
                <div class="BoxCheck" v-bind:class="{ activeFiltre: Tax }">
                  <i
                    aria-hidden="true"
                    v-if="Tax"
                    class="v-icon checkIcon material-icons theme--light"
                  >check</i>
                </div>
                <span>Tax</span>
              </div>
              <div class="OneFilter secondFilter" v-on:click="toggleAudit()">
                <div class="BoxCheck" v-bind:class="{ activeFiltre: Audit }">
                  <i
                    aria-hidden="true"
                    v-if="Audit"
                    class="v-icon checkIcon material-icons theme--light"
                  >check</i>
                </div>
                <span>Audit</span>
              </div>
              <div class="OneFilter thirdFilter" v-on:click="toggleAdvisory()">
                <div class="BoxCheck" v-bind:class="{ activeFiltre: Advisory }">
                  <i
                    aria-hidden="true"
                    v-if="Advisory"
                    class="v-icon checkIcon material-icons theme--light"
                  >check</i>
                </div>
                <span>Advisory</span>
              </div>
            </div>
          </div>
        </div>
        <export-excel name="Credentials published" :fetch="exportFct">
          <button class="exportBtn">
            <div class="exportBtnBehavior">
              Export
              <img class="exportImg" src="@/assets/excel.svg" alt />
            </div>
          </button>
        </export-excel>
      </div>

      <span class="loaderEngagementFinder" v-if="SpinnerEngagementFinder">
        <b-spinner type="grow"></b-spinner>
      </span>

      <div class="EFTable" v-if="!SpinnerEngagementFinder">
        <v-data-table
          :items="credentialsTable"
          @click:row="handleClick"
          :options.sync="PaginationCredentials"
          :items-per-page="7"
          @update:items-per-page="getItemPerPageCredentials"
          :server-items-length="options.Credentials.totalItems"
          :footer-props="{
                        itemsPerPageOptions: [7, 10], 
                    }"
        >
          <template v-slot:body="{items}">
            <tr class="tabHeader">
              <th v-for="(header ,  index) in headersCredentials" :key="header.text">
                <div class="headresContainer">
                  {{ header.text }}
                  <img
                    class="filterImg"
                    @click="showInputFilter(index,true)"
                    v-show="header.value != 'metierGu.title'"
                    src="@/assets/filter-filled-tool-symbol.svg"
                    alt
                  />

                  <i
                    class="material-icons arrowForSort"
                    @click="orderBy(index ,header.value )"
                    v-bind:class="{arrowForSortTranslate : arrowDown[index]}"
                  >arrow_upward</i>

                  <transition v-if="showSearch[index]">
                    <div class="inputFilterContainer">
                      <div class="columnFilter curs" v-if="header.value == 'insertedDate'">
                        <i
                          @click="showHeaderDate()"
                          class="material-icons headerDateIcon"
                        >date_range</i>
                        <input v-model="searchDate" type="text" class="headerInputDate" />
                        <i
                          class="material-icons closeIcon"
                          @click="showInputFilter(index,false)"
                        >close</i>
                        <v-date-picker
                          v-bind:class="{activeDatePicker : activePickerheader}"
                          v-model="searchDate"
                          no-title
                          class="headerDatePicker"
                        >
                          <v-btn text class="btn Cancel" @click="showHeaderDate()">Cancel</v-btn>
                          <v-btn text class="btn save" @click="filterByDate()">OK</v-btn>
                        </v-date-picker>
                      </div>
                      <input
                        type="text"
                        v-if="header.value != 'insertedDate'"
                        @keyup.enter="valueInputFilter()"
                        v-model="ValueSearch[index]"
                        class="columnFilter"
                      />
                      <i
                        class="material-icons closeIcon"
                        v-if="header.value != 'insertedDate'"
                        @click="showInputFilter(index,false)"
                      >close</i>
                    </div>
                  </transition>
                </div>
              </th>
            </tr>
            <tr
              v-for="(item, index)  in items"
              v-bind:class="{ stripedTab : checkRow(index)}"
              :key="item.id"
              class="dataRows"
              @click="handleClick(item)"
            >
              <td>{{ item.accountGlobalUltimateParentName }}</td>
              <td>{{ item.accountLegalName }}</td>
              <td>{{ item.metierGu.title }}</td>
              <td>{{ item.engagementDescription }}</td>
              <td>{{ item.contactEpfirstName }} {{ item.contactEplastName }}</td>
              <td>{{ item.contactEmfirstName }} {{ item.contactEmlastName }}</td>
              <td>{{ item.insertedDate | formatDate }}</td>
              <td>{{ item.credentialEndDate | formatDate }}</td>
              <td>{{ item.credentialTotalFees}} €</td>
              <td>
                <v-chip
                  v-bind:style="{ background: getBackColor(item.relanceNumber) }"
                  v-if="item.relanceNumber != NULL"
                >
                  <span
                    class="boldChips"
                    v-bind:style="{ color: getTextColor(item.relanceNumber) }"
                  >{{ item.relanceNumber }}</span>
                </v-chip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>
    <transition name="fade">
      <div class="shadow" v-if="openPopUp" v-on:click="CloseopenPopUp()"></div>
    </transition>
    <transition name="fade">
      <v-row class="EFPopUpRow" v-if="openPopUp">
        <v-col cols="3" v-on:click="CloseopenPopUp()"></v-col>
        <v-col cols="12" md="6" class="EFPopUpCol">
          <i class="material-icons closePopUpIcon" @click="CloseopenPopUp()">close</i>
          <div class="EFPopUpColContainer">
            <div class="EFPopUpColTitle">{{ credentialClicked.accountLegalName }}</div>

            <v-row class="EFPopUpRows">
              <v-col cols="12">
                <div class="PopUpSecondSubTitle">Engagement title</div>
                <div
                  type="text"
                  class="popUpInputs"
                  v-bind:class="{requiredInput : required}"
                >{{ credentialClicked.engagementDescription }}</div>
                <div class="clear"></div>
                <div class="PopUpSecondSubTitle">Métier</div>
                <div type="text" class="popUpInputs">{{ credentialClicked.metierGu.title }}</div>

           
                <div class="clear"></div>
                <div class="PopUpSecondSubTitle">Bu</div>
                <div type="text" class="popUpInputs">{{credentialClicked.businessUnit}}</div>

                
                <div class="clear"></div>
                <div class="PopUpSecondSubTitle">Profit center</div>
                <div type="text" class="popUpInputs">{{credentialClicked.profitCenter}}</div>

                <div class="clear"></div>
                <div class="PopUpSecondSubTitle">Sector</div>
                <div name id class="popUpInputs" v-bind:class="{selectActive : marketsActive}">
                  <div class="selectHead">
                    <div
                      class="chosenValues"
                      v-for="(item , index) in markets"
                      :key="index"
                    >{{ item.marketGu.title }}</div>
                  </div>
                </div>
                <!-- <div type="text" class="popUpInputs">{{ credentialClicked.accountSectorDescription}}</div> -->
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="PopUpSecondSubTitle">Engagement partner</div>
                <div
                  type="text"
                  class="popUpInputs"
                >{{ credentialClicked.contactEpfirstName }} {{ credentialClicked.contactEplastName }}</div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="PopUpSecondSubTitle">Engagement manager</div>
                <div
                  type="text"
                  class="popUpInputs"
                  v-bind:class="{requiredInput : required}"
                >{{ credentialClicked.contactEmfirstName }} {{ credentialClicked.contactEmlastName }}</div>
              </v-col>
            </v-row>
            <div class="separate"></div>
            <v-row>
              <v-col cols="12">
                <!-- <div class="PopUpSecondSubTitle">
                              Description
                            </div>
                            <div name="" class="popUpsTextArea"></div>                         
                <div class="clear"></div>-->
                <div class="PopUpSecondSubTitle">Estimated total fees</div>
                <div class="popUpInputs">
                  {{ credentialClicked.credentialTotalFees }}
                  <i
                    class="material-icons euroIcon"
                  >euro_symbol</i>
                </div>
              </v-col>
            </v-row>
            <div class="separate"></div>
            <v-row class="EFPopUpRows">
              <v-col cols="12" md="6">
                <div class="PopUpSecondSubTitle">Engagement start date</div>
                <div class="popUpInputs">
                  <i class="material-icons dateIcon">date_range</i>

                  <span
                    class="insertedDatesMargin"
                  >{{ credentialClicked.insertedDate | formatDate }}</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="PopUpSecondSubTitle">Engagement end date</div>

                <div class="popUpInputs">
                  <i class="material-icons dateIcon">date_range</i>

                  <span
                    class="insertedDatesMargin"
                  >{{ credentialClicked.credentialEndDate | formatDate }}</span>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <div class="PopUpSecondSubTitle">Technology</div>
                <!-- technologies -->
                <!-- <div name id class="popUpInputs" v-bind:class="{selectActive : TechnologiesActive}">
                  <div class="selectHead" @click="technologyActive()">
                    All technologies
                    <i class="material-icons selectArrowDown">arrow_drop_down</i>
                  </div>
                  <div v-if="TechnologiesActive" class="optioncontains">
                    <div
                      class="options"
                      value
                      v-for="technology in technologies"
                      :key="technology.technologyGu.id"
                    >
                      <span class="titles">{{ technology.technologyGu.title }}</span>
                    </div>
                  </div>
                </div>-->
                <div name id class="popUpInputs" v-bind:class="{selectActive : TechnologiesActive}">
                  <div class="selectHead">
                    <div
                      class="chosenValues"
                      v-for="(item , index) in technologies"
                      :key="index"
                    >{{ item.technologyGu.title }}</div>
                  </div>
                </div>
                <!-- end technologies-->
                <div class="clear"></div>

                <div class="PopUpSecondSubTitle">Customer challenges</div>
                <div name class="popUpsTextArea" id>{{ credentialClicked.clientChallenges }}</div>
                <div class="clear"></div>

                <div class="PopUpSecondSubTitle">Scoped countries</div>

                <!-- countries -->
                <!-- <div name id class="popUpInputs" v-bind:class="{selectActive : countriesActive}">
                  <div class="selectHead" @click="countryActive()">
                    All countries
                    <i class="material-icons selectArrowDown">arrow_drop_down</i>
                  </div>
                  <div v-if="countriesActive" class="optioncontains">
                    <div
                      class="options"
                      value
                      v-for="country in countries"
                      :key="country.countryGu.id"
                    >
                      <span class="titles">{{ country.countryGu.title }}</span>
                    </div>
                  </div>
                </div>-->
                <div name id class="popUpInputs" v-bind:class="{selectActive : countriesActive}">
                  <div class="selectHead">
                    <div
                      class="chosenValues"
                      v-for="(item , index) in countries"
                      :key="index"
                    >{{ item.countryGu.title }}</div>
                  </div>
                </div>
                <!-- end countries -->

                <div class="clear"></div>
              </v-col>
            </v-row>
            <div class="DescBoxPopUP">
              <span
                class="DescContext"
              >This client cannot be quoted within the context of this engagement outside of KPMG without prior validation from the French Lead Partner / Engagement Manager</span>
            </div>
          </div>
          <div class="EFPopUpColFooter">
            <div class="EFPopUpColFooterBtns">
              <button class="btn Cancel" @click="openPopUp = false">Close</button>
            </div>
          </div>
        </v-col>
        <v-col cols="3" v-on:click="CloseopenPopUp()"></v-col>
      </v-row>
    </transition>
  </div>
</template>

<script>
import $ from "jquery";
import api from "../mixins/api";
import endPoints from "../mixins/endPoints";

export default {
  name: "EngagementFinder",
  mixins: [api, endPoints],

  data() {
    return {
      baseUrl: window.baseUrlEngagementFinder,
      propotionsActive: false,
      countriesActive: false,
      marketsActive: false,
      TechnologiesActive: false,

      openPopUp: false,
      Tax: true,

      Audit: true,
      Advisory: true,
      credentialsTable: [],
      credentialClicked: null,

      propositions: null,
      markets: null,
      countries: null,
      technologies: null,

      objToExport: [],
      taxFilter: "",
      AuditFilter: "",
      AdvisoryFilter: "",
      MultiFilter: "",
      showSearch: [],
      ValueSearch: [],
      filterByColumn: "",
      lastFilter: "",
      required: false,
      arrowDown: [],
      OrderBy: "",
      queryMultiFilter: "",
      allFilter: "",
      picker: new Date().toISOString().substr(0, 10),
      cridentialDate: null,
      activePicker: false,
      searchDate: new Date().toISOString().substr(0, 10),
      activePickerheader: false,
      SpinnerEngagementFinder: true,

      headersCredentials: [
        {
          text: "GUP",
          align: "left",
          value: "accountGlobalUltimateParentName"
        },
        { text: "Customer", value: "accountLegalName" },
        // { text: "Sector", value: "AccountSectorDescription" },
        { text: "Métiers", value: "metierGu.title" },
        { text: "Engagement", value: "engagementDescription" },
        { text: "Partner", value: "contactEpfirstName" },
        { text: "Manager", value: "contactEmfirstName" },
        { text: "Engagement start date", value: "insertedDate" },
        { text: "Engagement end date", value: "credentialEndDate" },
        { text: "Estimated fees", value: "credentialTotalFees" },
        { text: "Reminders", value: "relanceNumber" }
      ],
      Relaunches: "Relaunches",
      options: {
        Credentials: {
          top: 7,
          skip: 0,
          totalItems: 0
        }
      },
      PaginationCredentials: {}
    };
  },
  methods: {
    showHeaderDate() {
      this.activePickerheader = !this.activePickerheader;
    },

    getExcelData() {
      return this.get(
        this.baseUrl +
          this.getFilter +
          this.published +
          this.allFilter +
          "&$expand=MetierGu"
      );
    },
    async exportFct() {
      // if(this.exportActive){
      let res = await this.getExcelData();
      let objToExp = res.data.value;
      this.objToExport = [];
      for (let index = 0; index < objToExp.length; index++) {
        let obj = {
          GUP: objToExp[index].accountGlobalUltimateParentName,
          Customer: objToExp[index].accountLegalName,
          Metiers: objToExp[index].metierGu.title,
          Engagement: objToExp[index].engagementDescription,
          Partner:
            objToExp[index].contactEpfirstName +
            " " +
            objToExp[index].contactEplastName,
          Manager:
            objToExp[index].contactEmfirstName +
            " " +
            objToExp[index].contactEmlastName,
          "Engagement start date": objToExp[index].insertedDate,
          "Engagement end date": objToExp[index].credentialEndDate,
          "Estimated fees": objToExp[index].credentialTotalFees + " €",
          Reminders: objToExp[index].relanceNumber
        };
        this.objToExport.push(obj);
      }
      return this.objToExport;
    },
    orderBy(index, column) {
      if (this.arrowDown[index] == null) {
        this.arrowDown = [];
        this.arrowDown[index] = false;
        this.arrowDown = Object.assign([], this.arrowDown);
        if (column == "metierGu.title") {
          this.OrderBy = "%20%20&%24orderby=metierGu/title%20asc";
        } else {
          this.OrderBy = "%20%20&%24orderby=" + column + "%20asc";
        }
      } else if (this.arrowDown[index] == false) {
        this.arrowDown[index] = true;
        this.arrowDown = Object.assign([], this.arrowDown);
        if (column == "metierGu.title") {
          this.OrderBy = "%20%20&%24orderby=metierGu/title%20desc";
        } else {
          this.OrderBy = "%20%20&%24orderby=" + column + "%20desc";
        }
      } else {
        this.arrowDown[index] = null;
        this.arrowDown = Object.assign([], this.arrowDown);
        this.OrderBy = "";
      }

      this.Filter();
    },
    checkRow(index) {
      if (index % 2 == 0) {
        return false;
      }
      return true;
    },
    showInputFilter(index, val) {
      this.showSearch = [];
      this.showSearch[index] = val;
      this.showSearch = Object.assign([], this.showSearch);
      if (!val) {
        this.valueInputFilter();
      }
    },
    valueInputFilter() {
      this.filterByColumn = "";
      for (let index = 0; index < this.headersCredentials.length; index++) {
        if (this.ValueSearch[index] != null && this.ValueSearch[index] != "") {
          if (
            this.headersCredentials[index].value == "credentialTotalFees" ||
            this.headersCredentials[index].value == "relanceNumber"
          ) {
            this.filterByColumn =
              this.filterByColumn +
              "%20and%20" +
              this.headersCredentials[index].value +
              "%20eq%20" +
              this.ValueSearch[index] +
              "";
          } else if (this.headersCredentials[index].value == "insertedDate") {
            let day = "";
            let month = "";
            let year = "";
            for (let index = 8; index < 10; index++) {
              day = day + this.searchDate[index];
            }
            for (let index = 5; index < 7; index++) {
              month = month + this.searchDate[index];
            }
            for (let index = 0; index < 4; index++) {
              year = year + this.searchDate[index];
            }
            this.filterByColumn =
              this.filterByColumn +
              "%20and%20year(insertedDate)%20eq%20" +
              year +
              "%20and%20month(insertedDate)%20eq%20" +
              month +
              "%20and%20day(insertedDate)%20%20eq%20" +
              day +
              "";
          } else if (
            this.headersCredentials[index].value == "contactEpfirstName"
          ) {
            this.filterByColumn =
              this.filterByColumn +
              "%20and%20" +
              "(contains(contactEpfirstName , '" +
              this.ValueSearch[index] +
              "') or contains(contactEplastName , '" +
              this.ValueSearch[index] +
              "'))";
            ("')");
          } else if (
            this.headersCredentials[index].value == "contactEmfirstName"
          ) {
            this.filterByColumn =
              this.filterByColumn +
              "%20and%20" +
              "(contains(contactEmfirstName , '" +
              this.ValueSearch[index] +
              "') or contains(contactEmlastName , '" +
              this.ValueSearch[index] +
              "'))";
            ("')");
          } else {
            this.filterByColumn =
              this.filterByColumn +
              "%20and%20" +
              "contains(" +
              this.headersCredentials[index].value +
              "%2C'" +
              this.ValueSearch[index] +
              "')";
          }
        }
      }
      this.Filter();
    },
    filterByDate() {
      this.ValueSearch[7] = this.searchDate;
      this.showHeaderDate();
      this.valueInputFilter();
    },
    handleClick(value) {
      for (let index = 0; index < this.showSearch.length; index++) {
        if (this.showSearch[index] == true) {
          this.showSearch[index] = false;
          this.showSearch = Object.assign([], this.showSearch);
        }
      }
      this.credentialClicked = value;
      this.openPopUp = true;
      this.getCridentialsCountries(this.credentialClicked.id);
      this.getCridentialsMarket(this.credentialClicked.id);
      this.getCridentialsTechnologies(this.credentialClicked.id);
    },
    getCridentialsMarket(id) {
      this.get(
        this.baseUrl + this.CridentialsMarkets + id + "&$expand=marketGu"
      )
        .then(res => {
          this.markets = res.data.value;
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    CloseopenPopUp() {
      this.openPopUp = false;
      this.propotionsActive = false;
      this.countriesActive = false;
      this.marketsActive = false;
      this.TechnologiesActive = false;
    },
    toggleTax() {
      this.Tax = !this.Tax;
      this.Filter();
    },
    toggleAudit() {
      this.Audit = !this.Audit;
      this.Filter();
    },
    toggleAdvisory() {
      this.Advisory = !this.Advisory;
      this.Filter();
    },

    Filter() {
      if (!this.Tax) {
        this.taxFilter = "%20and%20metierGu%2Ftitle%20ne%20'Tax'";
      } else {
        this.taxFilter = "";
      }

      if (!this.Audit) {
        this.AuditFilter = "%20and%20metierGu%2Ftitle%20ne%20'Audit'";
      } else {
        this.AuditFilter = "";
      }

      if (!this.Advisory) {
        this.AdvisoryFilter = "%20and%20metierGu%2Ftitle%20ne%20'Advisory'";
      } else {
        this.AdvisoryFilter = "";
      }
      if (this.MultiFilter != "") {
        this.queryMultiFilter =
          "%20and%20(contains(accountGlobalUltimateParentName%2C'" +
          this.MultiFilter +
          "')%20or%20contains(contactEmfirstName%2C'" +
          this.MultiFilter +
          "')%20or%20contains(contactEpfirstName%2C'" +
          this.MultiFilter +
          "')%20or%20contains(accountLegalName%2C'" +
          this.MultiFilter +
          "')%20or%20contains(engagementDescription%2C'" +
          this.MultiFilter +
          "'))";
      } else {
        this.queryMultiFilter = "";
      }

      this.allFilter =
        this.queryMultiFilter +
        this.filterByColumn +
        this.taxFilter +
        this.AuditFilter +
        this.AdvisoryFilter +
        this.OrderBy;
      this.options.Credentials.skip = 0;
      this.PaginationCredentials.page = 1;
      this.getCredentials();
    },

    getCredentials() {
      this.get(
        this.baseUrl +
          this.getFilter +
          this.published +
          this.allFilter +
          "&$expand=MetierGu&%24top=" +
          this.options.Credentials.top +
          "&%24skip=" +
          this.options.Credentials.skip
      )
        .then(res => {
          this.credentialsTable = res.data.value;
          this.options.Credentials.totalItems = res.data["@odata.count"];
          this.SpinnerEngagementFinder = false;
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    getCridentialsCountries(id) {
      this.get(
        this.baseUrl + this.CridentialsCountries + id + "&$expand=countryGu"
      )
        .then(res => {
          this.countries = res.data.value;
        })
        .catch(err => {
          window.console.log(err);
        });
    },
    getCridentialsTechnologies(id) {
      this.get(
        this.baseUrl +
          this.CridentialsTechnologies +
          id +
          "&$expand=technologyGu"
      )
        .then(res => {
          this.technologies = res.data.value;
        })
        .catch(err => {
          window.console.log(err);
        });
    },

    countryActive() {
      this.countriesActive = !this.countriesActive;
      this.propotionsActive = false;
      this.marketsActive = false;
      this.TechnologiesActive = false;
    },
    technologyActive() {
      this.TechnologiesActive = !this.TechnologiesActive;
      this.propotionsActive = false;
      this.countriesActive = false;
      this.marketsActive = false;
    },
    getItemPerPageCredentials(val) {
      if (this.options.Credentials.top != val) {
        this.options.Credentials.top = val;
        this.getCredentials();
      }
    },
    getBackColor(calories) {
      if (calories > 2) {
        return "#FAE2E2 !important";
      } else if (calories > 1) {
        return "#FAE3CD !important";
      } else {
        return "#F1FBFC !important";
      }
    },
    getTextColor(calories) {
      if (calories > 3) {
        return "#BF0E08 !important";
      } else if (calories > 1) {
        return "#95591E !important";
      } else {
        return "#007489 !important";
      }
    }
  },
  mounted() {
    $(".v-data-footer")
      .find(".v-data-footer__select")
      .addClass("dataFooterNone");
    this.getCredentials();
  },
  watch: {
    PaginationCredentials(newval) {
      if (newval) {
        this.options.Credentials.top = newval.itemsPerPage;
        this.options.Credentials.skip = newval.itemsPerPage * (newval.page - 1);
        this.getCredentials();
      }
    }
  }
};
</script>
<style  scoped>
.v-data-table__wrapper{
  min-height: 120px;
}
.EngagementFinder {
  padding: 24px;
  background-color: #fafafa;
  width: 100%;
  height: 100vh;
  position: relative;
  border-right: 1px solid #e4e7eb;
}
.EngagementFinder .EngagementFinderContainer {
  border: 1px solid #e4e7eb;
  width: 100%;
  position: relative;
  background-color: white;
  min-height: 584px;
  padding: 18px;
}
.chosenValues {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 10px;
  font-weight: bold;
  color: #152935;
  height: 30px;
  background: #f2f2f2;
  border-radius: 15px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 13px;
  font-size: 13px;
}
.EngagementFinderContainer .header {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: yellow */
}
.EngagementFinderContainer .header .searchPart {
  width: 500px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.searchBtn {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.inpSearchDiv {
  position: relative;
}
.searchIcon {
  position: absolute;
  left: 13px;
  top: 6px;
  font-size: 21px !important;
  cursor: pointer;
}
.searchPart .inpSearch {
  outline: none;
  color: #66788a;
  line-height: 20px;
  padding: 8px 0;
  padding-left: 40px;
  width: 250px;
  height: 32px;
  background: #f5f6f7 0% 0% no-repeat padding-box;
  border: 1px solid #e4e7eb;
}
.searchPart .Title {
  font-weight: bold;
  font-size: 16px;
  color: #152935;
}
.exportBtn {
  background-color: white;
  outline: none;
  border: solid 1px #2e7d32;
  width: 117px;
  height: 40px;
  color: #152935;
}
.BoxCheck {
  width: 18px;
  height: 18px;
  border-radius: 1px;
  border: solid #1070ca 1px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkIcon {
  color: white !important;
  font-size: 21px !important;
}
.filtrePart {
  width: 217px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  position: relative;
}
.OneFilter {
  color: #425a70;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.firstFilter {
  width: 47px;
}
.secondFilter {
  width: 60px;
}
.thirdFilter {
  width: 86px;
}
.activeFiltre {
  background-color: #1070ca;
}
.EFTable {
  border: solid 1px #f3f3f3;
  margin-top: 15px;
}
.shadow {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: #00000039;
  /* transition: opacity .5s; */
}
.EFPopUpRow {
  position: absolute;
  height: 515px;
  width: 100%;
  top: 6%;
  left: 0;
  margin: 0 !important;
}
.EFPopUpCol {
  background-color: white;
  border-top: 4px solid #1070ca;
  position: relative;
  height: 100%;
  box-shadow: 0px 12px 24px #0000001a;
  scrollbar-color: red yellow;
  padding-top: 34px;
}
.EFPopUpColTitle {
  font-weight: bold;
  color: #5a6872;
  margin-top: 14px;
  font-size: 28px;
}
.EFPopUpRows {
  margin-top: 35px;
}
.PopUpSubTitle {
  font-weight: bold;
  color: #234361;
  font-size: 18px;
}
.PopUpSecondSubTitle {
  font-weight: bold;
  color: #152935;
  font-size: 14px;
}
.popUpDescription {
  margin-top: 10px;
  font-size: 12px;
  color: #c9c9c9;
}
.popUpInputs {
  position: relative;
  margin-top: 10px;
  height: 40px;
  border: 1px solid #e4e7eb;
  width: 98%;
  padding-left: 16px;
  color: #152935;
  display: flex;
  align-items: center;
}
.selectHead {
  cursor: pointer;
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 16px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}
.popUpsTextArea {
  margin-top: 10px;
  height: 32px;
  width: 98%;
  padding: 16px;
  outline: none;
  height: 105px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e4e7eb;
  color: #152935;
}
.separate {
  width: 99%;
  height: 1px;
  background-color: #e4e7eb;
}
.optioncontains {
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 39px;
  background-color: white;
  width: 100%;
  max-height: 90px;
  overflow: hidden;
  overflow-y: scroll;
  border: #c4d4e8 solid 1px;
  border-top: none;
  z-index: 2;
  height: auto;
}
.optioncontains :hover {
  background-color: #c4d4e8;
}
.optioncontains .options {
  display: flex;
  height: 40px;
  padding-left: 35px;
  align-items: center;
}
.selectActive {
  border: #c4d4e8 solid 1px !important;
}
.options .titles {
  margin-left: 25px;
}
.EFPopUpColFooter {
  position: absolute;
  width: 100%;
  height: 70px;
  background-color: #fafafa;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  padding-right: 30px;
}
.EFPopUpColFooterBtns {
  display: flex;
  align-items: center;
  width: 200px;
  justify-content: flex-end;
}
.EFPopUpColFooterBtns .btn {
  width: 128px;
  height: 40px;
  outline: none;
  border: none;
  color: white;
  font-weight: bold;
  border-radius: 0 !important;
}
.EFPopUpColFooterBtns .Cancel {
  background-color: transparent;
  color: #1070ca;
  font-weight: 100;
}

.EFPopUpColContainer {
  height: calc(100% - 56px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.clear {
  height: 10px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.v-data-table-header {
  background-color: #fafafa !important;
}
.exportImg {
  width: 20px;
}
.exportBtnBehavior {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.selectArrowDown {
  position: absolute;
  right: 10px;
}
.theme--light.v-data-table thead tr th {
  text-align: left !important;
}
.tabHeader {
  position: relative;
  height: 48px;
  background: #fafafa;
  border: 1px solid #dfe3e6;
  text-align: left;
}
.hoverTr {
  background-color: #c4d4e8 !important;
}
.stripedTab {
  background: #f5f6f7 !important;
  border: 1px solid #dfe3e6;
}
.v-data-table th {
  border-bottom: 1px solid #dfe3e6;
}
.filterImg {
  width: 10px;
}
.headresContainer {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 110px;
}
.inputFilterContainer {
  height: 32px;
  width: 100%;
  position: absolute;
  left: -16px;
  display: flex;
  align-items: center;
  bottom: -47px;
  width: 142px;
  z-index: 99;
}
.columnFilter {
  height: 32px;
  width: 100%;
  border: #267ad5 solid 1px;
  background: white;
  border-radius: 1px;
  display: flex;
  align-items: center;
}
.closeIcon {
  position: absolute;
  right: 5px;
  font-size: 18px;
  color: #bf0e08;
}
.arrowForSort {
  font-size: 19px;
  transition-duration: 0.5s;
  color: #657179;
}
.arrowForSortTranslate {
  transform: rotate(180deg);
  transition-duration: 0.5s;
}

.closePopUpIcon {
  position: absolute;
  right: 14px;
  top: 7px;
  font-size: 17px;
  cursor: pointer;
}
.dataRows {
  cursor: pointer;
}
.dataRows:hover {
  background-color: rgba(219, 234, 247, 0.83) !important;
}
.dateIcon {
  color: #1070ca;
  position: absolute;
  left: 16px;
  cursor: pointer;
}

.insertedDatesMargin {
  margin-left: 34px;
  cursor: pointer;
}
.datePicker {
  display: none;
  position: absolute;
  top: 89%;
  left: 35px;
  z-index: 99;
}
.activeDatePicker {
  display: block !important;
}
.curs {
  cursor: pointer;
}
.headerDateIcon {
  color: #1070ca;
  position: absolute;
  left: 4px;
  cursor: pointer;
}
.headerInputDate {
  position: absolute;
  height: 100%;
  border: none;
  outline: none;
  top: 0;
  left: 34px;
  width: calc(100% - 35px);
}
.headerDatePicker {
  display: none;
  /* position: absolute; */
  top: 14vh;
  left: calc(50vw - 145px);
  height: 400px;
  position: fixed;
}
.v-date-picker-table .v-btn {
  display: none;
}
.v-card > .v-card__progress + :not(.v-btn):not(.v-chip),
.v-card > :first-child:not(.v-btn):not(.v-chip) {
  height: 322px !important;
}
.headerDatePicker .btn {
  width: 128px;
  height: 40px;
  outline: none;
  border: none;
  color: white;
  font-weight: bold;
}
.headerDatePicker .Cancel {
  background-color: transparent;
  color: #1070ca;
  font-weight: 100;
}
.headerDatePicker .save {
  background-color: #1070ca;
}
.euroIcon {
  position: absolute;
  right: 10px;
  color: #657179;
  font-size: 22px !important;
}
</style>